angular = require( 'angular' )

app = angular.module( 'workflow.app' )

app.directive( 'searchResultPreview', require( './SearchResultPreview' ) )
app.directive( 'searchResultPreviewScoped', () ->
  return {
    template: require('./search-result-preview.html'),
    scope: { result: "=" }
    controller: require('./SearchResultPreview')().controller
  }
)

app.directive( 'displayItem', require( './DisplayItem' ) )
